// extracted by mini-css-extract-plugin
export default {"modal":"Xfa-z","modalContent":"Yfa-z","footer":"Zfa-z","cancelBtn":"_fa-z","disabled":"aga-z","formWrapper":"bga-z","fade":"cga-z","fade-in":"dga-z","iframe":"ega-z"};